import { Component } from '@angular/core';

@Component({
  selector: 'cap-pbi-reports',
  template: '<router-outlet></router-outlet>',
})
export class ReportsLayoutComponent {
}
